export class HospModel {
    hospCode: string;
    hospName: string;
    label: string;
}

// export function getHopitalJson() {
//     return [
//         {
//             "hospital": {
//                 "code": "B001",
//                 "name": "กรุงเทพ",
//             }
//         },
//         {
//             "hospital": {
//                 "code": "B002",
//                 "name": "กรุงเทพคริสเตียน",
//             }
//         },
//         {
//             "hospital": {
//                 "code": "B007",
//                 "name": "สมิติเวช ธนบุรี",
//             }
//         },
//         {
//             "hospital": {
//                 "code": "B008",
//                 "name": "เกษมราษฎร์ (ประชาชื่น)",
//             }
//         }
//     ]
// }